import $ from 'jquery';
import bodymovin from 'lottie-web';

var animation;
window.addEventListener('px-ready',function(){
    window.setTimeout(function(){
        $('.px-bodymovin').each(function(){
            if(!jQuery(this).find('svg').length){
                console.log('creating anim')
                var animPath = $(this).attr('data-pattern');
                animation = bodymovin.loadAnimation({
                    container: document.getElementById($(this).attr('id')), // Required
                    path: template_dir+'/assets_src/lotties/'+animPath+'.json', // Required
                    renderer: 'svg', // Required
                    loop: false, // Optional
                    autoplay: true, // Optional
                    name: "patternanim", // Name for future reference. Optional.
                })
                animation.setSpeed(2);
            }
        })
    },1000)
})